import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _jsxFileName = "/Users/satya/Workspace/Callstack/react-navigation-core/src/views/withNavigationFocus.js";
import React from 'react';
import hoistStatics from 'hoist-non-react-statics';
import withNavigation from './withNavigation';
export default function withNavigationFocus(Component) {
  var ComponentWithNavigationFocus = function (_React$Component) {
    _inherits(ComponentWithNavigationFocus, _React$Component);

    function ComponentWithNavigationFocus(props) {
      var _this;

      _classCallCheck(this, ComponentWithNavigationFocus);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ComponentWithNavigationFocus).call(this, props));
      _this.subscriptions = [props.navigation.addListener('didFocus', function () {
        return _this.setState({
          isFocused: true
        });
      }), props.navigation.addListener('willBlur', function () {
        return _this.setState({
          isFocused: false
        });
      })];
      _this.state = {
        isFocused: props.navigation ? props.navigation.isFocused() : false
      };
      return _this;
    }

    _createClass(ComponentWithNavigationFocus, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.subscriptions.forEach(function (sub) {
          return sub.remove();
        });
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(Component, _extends({}, this.props, {
          isFocused: this.state.isFocused,
          ref: this.props.onRef,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 33
          }
        }));
      }
    }]);

    return ComponentWithNavigationFocus;
  }(React.Component);

  ComponentWithNavigationFocus.displayName = "withNavigationFocus(" + (Component.displayName || Component.name) + ")";
  return hoistStatics(withNavigation(ComponentWithNavigationFocus, {
    forwardRef: false
  }), Component);
}